import React, { useEffect, useState } from "react";
import BlockButton from "../components/block-button";
import UnderlineButton from "../components/underline-button";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import {
  createPairingDeviceOrder,
  createSwapOrder,
  createWatchOrder,
  inquireCompanionPairFlow,
  inquireCompanionPlans, inquireServiceAndEmergencyAddress
} from "../services/pairing-service";
import {
  CapturedAddress,
  CreateWatchOrderResponse, InquireAddressResponse,
  planState
} from "../states/plan-state/plan-atoms";
import { useRecoilValue, useSetRecoilState } from "recoil";
import keycloak from "../utils/keycloak";
import {
  Device,
} from "../models/companion-plan-response";
import { ThreeDots } from "react-loader-spinner";
import { Flow } from "../models/flow-enum";
import { InquireCompanionFlowResponse } from "../models/inquire-companion-flow-response";
declare var DataActivationController: any;
const ActivateSmartwatch = () => {
  const { t, i18n } = useTranslation();
  const navigate = useNavigate();
  const { companionPlansResponse, inquireCompanionFlowResponse } =
    useRecoilValue(planState);
  const setPlanState = useSetRecoilState(planState);
  const [loading, setLoading] = useState(false);
  const [addWatch, setAddWatch] = useState(false);
  const [isWarning, setIsWarning] = useState(false);
  const navigateEmergencyAddress = () => {
    navigate("/emergency-address");
  };

  const navigateRegisterAddress = () => {
    navigate("/register-address");
  };

  const navigateReplaceWarning = (device: Device) => {
    if (device.pairStatus !== "Active") {
      setIsWarning(true);
    } else {
      localStorage.setItem(
        "selectedPairAccountId",
        device?.pairAccountId.toString(),
      );
      localStorage.setItem(
        "selectedTmoBillingAccountId",
        inquireCompanionFlowResponse.tmoBillingAccountId.toString(),
      );
      navigate("/replace");
    }
  };

  const callAddWatch = () => {
    callCompanionPlans();
    setAddWatch(true);
  };

  const callCreateSwapOrder = () => {
    if (
      inquireCompanionFlowResponse?.devices?.length &&
      inquireCompanionFlowResponse?.devices[0].pairStatus !== "Active"
    ) {
      setIsWarning(true);
    } else {
      setLoading(true);
      createSwapOrder({
        tmoBillingAccountId:
          inquireCompanionFlowResponse?.tmoBillingAccountId || 0,
        pairAccountId: inquireCompanionFlowResponse?.devices?.length
          ? inquireCompanionFlowResponse?.devices[0].pairAccountId
          : 0,
      }).then((response: CreateWatchOrderResponse) => {
        if (response?.customerOrderId) {
          setPlanState((prevState) => ({
            ...prevState,
            customerOrderId: response?.customerOrderId,
            createWatchOrderResponse: response,
          }));
          setLoading(false);
          response?.capturedAddress?.parameters.find(
            (x) => x.shortCode === "addressType",
          )?.value === "existing"
            ? navigateEmergencyAddress()
            : navigateRegisterAddress();
        } else {
          setLoading(true);
          navigate("/error");
        }
      });
    }
  };

  const navigateMyAccount = () => {
    window.location.href = process.env.REACT_APP_MY_ACCOUNT_URL || "";
  };

  const logoutAndLoginAgain = () => {
    keycloak &&
    keycloak.logout({
      redirectUri: process.env.REACT_APP_WATCH_APP_URL,
    });
  };

  const callAddressAction = () => {
    setLoading(true);
    inquireServiceAndEmergencyAddress({  accountId: Number(inquireCompanionFlowResponse.tmoBillingAccountId),})
      .then((response: InquireAddressResponse) => {
        if(!!response?.emergencyAddress) {
          setPlanState((prevState) => ({
            ...prevState,
            emergencyAddress: response.emergencyAddress,
            serviceAddress: response.serviceAddress,
          }));
          setLoading(false);
          if( response?.emergencyAddress?.parameters.find(
            (x) => x.shortCode === "addressType",
          )?.value === "existing") {
            CreateWatchOrder(response.serviceAddress, response.emergencyAddress);
          }
          else {
            navigateRegisterAddress();
          }
        }
        else {
          setLoading(false);
          navigate("/error");
        }
      });

  }

  const CreateWatchOrder = (serviceAddress: CapturedAddress, emergencyAddress: CapturedAddress) => {
    setLoading(true);
    createWatchOrder({
      iccid:
        localStorage.getItem("primaryDeviceIccid") ||
        localStorage.getItem("primaryIccid") ||
        "",
      accountId: Number(inquireCompanionFlowResponse.tmoBillingAccountId),
      planOfferId:
        inquireCompanionFlowResponse?.nextFlowPage ===
        Flow.NON_PAIRED_PLAN_FOUND
          ? null
          : Number(companionPlansResponse?.plans[0].id),
      eid: JSON.parse(localStorage.getItem("watchInfo")!).eid,
      pairAccountId: inquireCompanionFlowResponse?.devices?.length
        ? inquireCompanionFlowResponse?.devices[0].pairAccountId
        : null,
      emergencyAddress: emergencyAddress,
      serviceAddress: serviceAddress,
      byodActivation: true,
    })
      .then((response: CreateWatchOrderResponse) => {
        if (response?.customerOrderId) {
          setPlanState((prevState) => ({
            ...prevState,
            customerOrderId: response?.customerOrderId,
            createWatchOrderResponse: response,
          }));
          setLoading(false);
          navigateEmergencyAddress();
        } else {
          setLoading(false);
          navigate("/error");
        }
      })
      .catch((error: any) => {
        setLoading(false);
        console.error("An error occurred:", error.message);
      });
  };

  const CreatePairingDeviceOrder = () => {
    setLoading(true);
    createPairingDeviceOrder({
      iccid:
        localStorage.getItem("primaryDeviceIccid") ||
        localStorage.getItem("primaryIccid") ||
        "",
      accountId: Number(inquireCompanionFlowResponse.tmoBillingAccountId),
      planOfferId:
        inquireCompanionFlowResponse?.nextFlowPage ===
        Flow.NON_PAIRED_PLAN_FOUND
          ? null
          : Number(companionPlansResponse?.plans[0].id),
      eid: JSON.parse(localStorage.getItem("watchInfo")!).eid,
      pairAccountId: inquireCompanionFlowResponse?.devices?.length
        ? inquireCompanionFlowResponse?.devices[0].pairAccountId
        : null,
    })
      .then((response: CreateWatchOrderResponse) => {
        if (response?.customerOrderId) {
          setPlanState((prevState) => ({
            ...prevState,
            customerOrderId: response?.customerOrderId,
            createWatchOrderResponse: response,
          }));
          setLoading(false);
          response?.capturedAddress?.parameters.find(
            (x) => x.shortCode === "addressType",
          )?.value === "existing"
            ? navigateEmergencyAddress()
            : navigateRegisterAddress();
        } else {
          setLoading(false);
          navigate("/error");
        }
      })
      .catch((error: any) => {
        setLoading(false);
        console.error("An error occurred:", error.message);
      });
  };

  const callCompanionPlans = () => {
    setLoading(true);
    inquireCompanionPlans()
      .then((response) => {
        if (response?.isMaxWatchSubsExceeded) {
          window.location.href = process.env.REACT_APP_MY_ACCOUNT_URL || "";
        } else {
          setPlanState((prevState) => ({
            ...prevState,
            companionPlansResponse: response,
            imeiAndCustomerValid: true,
            maximumWatchSubsExceeded: response?.maxWatchSubsExceeded,
          }));
          setLoading(false);
        }
      })
      .catch((error) => {
        if (error.response && error.response.status === 401) {
          setLoading(false);
          setPlanState((prevState) => ({
            ...prevState,
            imeiAndCustomerValid: false,
          }));
          console.error("Unauthorized! Please log in again.");
        } else {
          console.error("An error occurred:", error.message);
        }
      });
  };

  const callInquireCompanionFlow = () => {
    setLoading(true);
    inquireCompanionPairFlow({
      iccid:
        localStorage.getItem("primaryDeviceIccid") ||
        localStorage.getItem("primaryIccid") ||
        "",
      eid: localStorage.getItem("eid") || "",
      imei: localStorage.getItem("deviceImei") || null,
    })
      .then((response: InquireCompanionFlowResponse) => {
        if (response.nextFlowPage === Flow.START_NEW_COMPANION_PLAN) {
          callCompanionPlans();
        }
        setPlanState((prevState) => ({
          ...prevState,
          inquireCompanionFlowResponse: response,
        }));
        setLoading(false);
      })
      .catch((error) => {
        setLoading(false);
      });
  };

  useEffect(() => {
    const lang = i18n.language?.substring(0, 2);
    localStorage.setItem("lang", lang);
    callInquireCompanionFlow();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [setPlanState, i18n.language]);

  const decidePairFlow = (flowResponse: InquireCompanionFlowResponse) => {
    switch (flowResponse.nextFlowPage) {
      case Flow.UNAUTHORIZED:
        return renderNotLinkedAccountSection();
      case Flow.START_NEW_COMPANION_PLAN:
        return renderPlanSection();
      case Flow.SINGLE_DEVICE_PAIRED:
        return renderOneWatchLinked();
      case Flow.MULTIPLE_DEVICES_PAIRED:
        return renderMaximumWatchSection(flowResponse);
      case Flow.MAX_DEVICE_PAIRING_LIMIT_REACHED:
        return renderMaximumWatchSection(flowResponse);
      case Flow.NO_DATA_PLAN_AVAILABLE:
        return renderNotCompatibleSection();
      case Flow.COMPANION_SIMCARD_CHANGE:
        return renderEidMatchSection();
      case Flow.NON_PAIRED_PLAN_FOUND:
        return renderNonPairedPlanSection(flowResponse.mainMsisdn || "");
      case Flow.NON_PAIRED_PLAN_FOUND_ON_OTHER_ACCOUNT:
        return renderNonPairedOnOtherAccountPlanSection();
      default:
        return null;
    }
  };

  const decidePageTitle = (flowResponse: InquireCompanionFlowResponse) => {
    switch (flowResponse.nextFlowPage) {
      case Flow.UNAUTHORIZED:
        return t("notLinkedAccountText");
      case Flow.START_NEW_COMPANION_PLAN:
        return t("activateWatchTitle");
      case Flow.SINGLE_DEVICE_PAIRED:
        return t("oneWatchLinkedTitle");
      case Flow.MULTIPLE_DEVICES_PAIRED:
        return t("multipleLinkedTitle");
      case Flow.MAX_DEVICE_PAIRING_LIMIT_REACHED:
        return t("maximumText");
      case Flow.NO_DATA_PLAN_AVAILABLE:
        return t("activateWatchTitle");
      case Flow.COMPANION_SIMCARD_CHANGE:
        return t("eidMatchTitle");
      case Flow.NON_PAIRED_PLAN_FOUND:
        return t("activateWatchTitle");
      case Flow.NON_PAIRED_PLAN_FOUND_ON_OTHER_ACCOUNT:
        return t("pairedOnOtherAccountTitle");
      default:
        return null;
    }
  };

  const onCancel = () => {
    const dataActivationController = DataActivationController;
    // @ts-ignore
    if (DataActivationController) {
      // @ts-ignore
      dataActivationController.doneSelected();
    } else {
      console.error("DataActivationController not found");
    }
  };

  const getPriceParts = (price: number) => {
    const [integerPart, decimalPart] = price.toFixed(2).split(".");
    return { integerPart, decimalPart };
  };

  const renderNotLinkedAccountSection = () => {
    return (
      <div className="layout-default-left">
        <p className="layout-default-left">{t("signInText")}</p>
        <BlockButton
          dataTestId="signInButton"
          text={t("signInButtonText")}
          onClick={logoutAndLoginAgain}
        />
      </div>
    );
  };

  const renderPendingChangeSection = () => {
    return (
      <div className="layout-default-left">
        <p className="layout-default-left">{t("pendingChangeText")}</p>
        <BlockButton
          dataTestId="signOutButton"
          text={t("signOutButtonText")}
          onClick={logoutAndLoginAgain}
        />
      </div>
    );
  };

  const renderNotCompatibleSection = () => {
    return (
      <div>
        <div className="alert-box">
          <div className="icon"></div>
          <div className="alert-content">
            <h3>{t("notCompatibleTitle")}</h3>
            <br />
            <p>{t("notCompatibleText")}</p>
          </div>
        </div>

        <BlockButton
          dataTestId="shopButton"
          text={t("shopButton")}
          onClick={navigateMyAccount}
        />

        <div className="button-container-center">
          <UnderlineButton
            click={onCancel}
            dataTestId="cancelButton"
            text={t("cancelText")}
          />
        </div>
        <p>{t("notCompatibleSubText")}</p>
      </div>
    );
  };

  const renderEidMatchSection = (): JSX.Element => {
    return (
      <div>
        <p>{t("eidMatchText")}</p>

        <BlockButton
          dataTestId="continueButton"
          text={t("continueButton")}
          onClick={callCreateSwapOrder}
        />

        <div className="button-container-center">
          <UnderlineButton
            click={onCancel}
            dataTestId="cancelButton"
            text={t("cancelText")}
          />
        </div>
      </div>
    );
  };

  const renderPlanSection = (
  ): JSX.Element => {
    return (
      <div>
        <p className="info-text">
          {t("shareMsisdnText", {
            msisdn: companionPlansResponse?.msisdnNumber,
          })}
        </p>

        <div className="scrollable-container">
          {companionPlansResponse?.plans?.map((x) => (
            <div className="scrollable-item" key={x.id}>
              <div className="card" key={x.id}>
                <div className="card-header">
                  <h2 className="title">{x.name}</h2>
                </div>
                <div className="card-body">
                  <p className="description">{x.toolTip}</p>
                  {
                    x.discToolTipHeader ? (
                      <p className="description-header">{x.discToolTipHeader}</p>
                    ) : <></>
                  }
                  {
                    x.discToolTip ? (
                      <p className="description">{x.discToolTip}</p>
                    ) : <></>
                  }
                  <hr className="solid" />
                  <div className="pricing">
                    <span className="currency">$</span>
                    <span className="price-container">
                      <span className="price">
                        {getPriceParts(x.bundleCalculatedPrice).integerPart}
                      </span>
                      {getPriceParts(x.price).decimalPart !== "00" ? (
                        <span className="cents">
                          {getPriceParts(x.bundleCalculatedPrice).decimalPart}
                        </span>
                      ) : null}
                    </span>
                    <span className="per-month">{t("monthInfo")}</span>
                    {x.bundleDiscountPrice > 0 ? (
                      <span className="original-price-text">
                        {getPriceParts(x.price).integerPart},
                        {getPriceParts(x.price).decimalPart} $
                      </span>
                    ) : (
                      <></>
                    )}
                  </div>
                  <span className="per-month">{t("extraTaxText")}</span>
                </div>
              </div>
            </div>
          ))}
        </div>

        <p data-testid="linkText">{t("learnMoreText")}</p>

        <BlockButton
          dataTestId="addPlanButton"
          text={t("addPlanText")}
          onClick={callAddressAction}
        />

        <div className="button-container-center">
          <UnderlineButton
            click={onCancel}
            dataTestId="cancelButton"
            text={t("cancelText")}
          />
        </div>
        <p>{t("troubleText")}</p>
      </div>
    );
  };

  const renderNonPairedPlanSection = (msisdn: string): JSX.Element => {
    return (
      <div>
        <p className="info-text">{t("includeText")}</p>
        <p className="info-text">
          {t("shareMsisdnText", {
            msisdn: msisdn,
          })}
        </p>

        <BlockButton
          dataTestId="continueButton"
          text={t("continueButton")}
          onClick={CreatePairingDeviceOrder}
        />

        <div className="button-container-center">
          <UnderlineButton
            click={onCancel}
            dataTestId="cancelButton"
            text={t("cancelText")}
          />
        </div>
        <p>{t("troubleText")}</p>
      </div>
    );
  };

  const renderNonPairedOnOtherAccountPlanSection = (): JSX.Element => {
    return (
      <div>
        <p className="info-text">{t("pairedOnOtherAccountText")}</p>

        <p className="info-text">{t("pairedOnOtherAccountSubText")}</p>

        <p className="info-text">{t("pairedOnOtherAccountInfoText")}</p>
        <BlockButton
          dataTestId="continueButton"
          text={t("continueButton")}
          onClick={callAddWatch}
        />

        <div className="button-container-center">
          <UnderlineButton
            click={onCancel}
            dataTestId="cancelButton"
            text={t("cancelText")}
          />
        </div>
      </div>
    );
  };

  const renderMaximumWatchSection = (
    flowResponse: InquireCompanionFlowResponse,
  ): JSX.Element => {
    return (
      <div>
        {flowResponse?.devices?.length === 3 ? (
          <p className="info-text">{t("maximumSubText")}</p>
        ) : (
          <></>
        )}

        {flowResponse?.devices?.length &&
          flowResponse.devices.map((device) => (
            <div className="replace-section" key={device.pairAccountId}>
              <h3 className="device-title">{device.name}</h3>
              <UnderlineButton
                className="underline-replace-button"
                click={() => navigateReplaceWarning(device)}
                dataTestId="replace"
                text={t("replaceButton")}
              />
            </div>
          ))}

        <BlockButton
          dataTestId="addWatchButton"
          disabled={
            flowResponse.nextFlowPage === Flow.MAX_DEVICE_PAIRING_LIMIT_REACHED
          }
          text={t("addWatchButton")}
          onClick={callAddWatch}
        />

        <div className="button-container-center">
          <UnderlineButton
            click={onCancel}
            dataTestId="cancelButton"
            text={t("cancelText")}
          />
        </div>
      </div>
    );
  };

  const renderOneWatchLinked = (): JSX.Element => {
    return (
      <div>
        <p className="info-text">{t("oneWatchLinkedText")}</p>
        <BlockButton
          dataTestId="replaceButton"
          text={t("replaceWatchButton")}
          onClick={() =>
            navigateReplaceWarning(inquireCompanionFlowResponse.devices[0])
          }
        />
        <BlockButton
          isReplace={true}
          dataTestId="addPlanButton"
          text={t("addPlanButton")}
          onClick={callAddWatch}
        />
        <div className="button-container-center">
          <UnderlineButton
            click={onCancel}
            dataTestId="cancelButton"
            text={t("cancelText")}
          />
        </div>
      </div>
    );
  };

  return (
    <div className="layout-default">
      {loading || !inquireCompanionFlowResponse?.nextFlowPage ? (
        <>
          {" "}
          <ThreeDots
            visible={true}
            height="80"
            width="80"
            color="#FFD200"
            radius="9"
            ariaLabel="three-dots-loading"
            wrapperClass="full-layout"
          />
        </>
      ) : (
        <div>
          <h2 className="watch-title" data-testid="activateTitle">
            {isWarning
              ? t("pendingChangeTitle")
              : decidePageTitle(
                inquireCompanionFlowResponse as InquireCompanionFlowResponse,
              )}
          </h2>
          {addWatch
            ? renderPlanSection()
            : isWarning
              ? renderPendingChangeSection()
              : decidePairFlow(
                inquireCompanionFlowResponse as InquireCompanionFlowResponse,
              )}
        </div>
      )}
    </div>
  );
};

export default ActivateSmartwatch;
